export default "__VITE_ASSET__BTj2EIC7__"